module.exports = {
  newsVal: '最新资讯',
  moreVal: '查看更多',
  partnerVal: '合作伙伴',
  placeVal: '播出平台',
  placePhoneVal: '播出平台',
  areaVal: '地区',
  areaPhoneVal: '地区',
  cateVal: '分类',
  yearVal: '年份',
  queryVal: '查询',
  modelInputVal: '模式搜索',
  chineseVal: '中国模式',
  outVal: '海外模式',
  adviceVal: '意见反馈',
  aboutVal: '关于我们',
  contactVal: '联系我们',
  declareVal: '版权声明',
  privateVal: '隐私保护',
  companyVal: '沪公网安备:31010602005167',
  recordVal: '备案号:沪ICP备14027572号-2',
  allVal: '全部',
  reportVal: '预定报告',
  tvBoChuVal: '电视播出平台',
  itemVal: '节目类型',
  bochuDateVal: '首播日期',
  totalItemsVal: '总播出季数',
  totalNumVal: '总播总集数',
  itemLongVal: '节目时长',
  reportTimeVal: '播出时间',
  reportPartVal: '播送时段',
  targetPeoVal: '目标观众年龄层',
  peoVal: '主持人',
  companyDoVal: '制作公司',
  webShowVal: '节目预览网址',
  itemItroduceVal: '节目简介',
  visionVal: '收视表现',
  judgeItemVal: '节目模式点评',
  itemPicVal: '节目图片及片花',
  commitVal: '发表评论',
  detailVal: '详情',
  inputSayVal: '说点什么吧...',
  indexVal: '首页',
  modelList: '节目模式库',
  modelReport: '模式全报告',
  modelSearch: '模式研究院',
  registe: '注册',
  nextStep: '下一步',
  hasAccount: '已有账号',
  loginNow: '立刻登录',
  welcome: '欢迎注册',
  mailVal: '请输入邮箱',
  phoneVal: '请输入电话',
  userVal: '请输入用户,不超过15位',
  passwordVal: '请输入8-16位密码',
  companVal: '请输入您的公司',
  leaderVal: '请输入您的职位',
  readBefore: '已阅读 ',
  readOld: ' 和 ',
  readTip: '已阅读版权声明和声明保护',
  readTipNew: '版权声明',
  readTipSec: '隐私保护',
  loginVal: '登录',
  welcomeBack: '欢迎回来',
  userEnter: '请输入用户名',
  passwordEnter: '请输入8-16位密码',
  noAccount: '还没有账号',
  registNow: '立即注册',
  hellow: '用户信息',
  confirmMsg: '请确认消息',
  confirmBtn: '确认',
  downLoad: '下载',
  allSearch: '请输入搜索内容',
  commentList: '评论列表',
  yearReport: '年报',
  monthReport: '月报',
  weekReport: '周报'
}
